<template>
    <section class="section sec-login">
        <div class="d-flex flex-wrap align-items-stretch">
            <div class="text-center bg-loading" v-if="loading_login === true">
                <div class="half-circle-spinner">
                    <div class="circle circle-1"></div>
                    <div class="circle circle-2"></div>
                </div>
            </div>
            <div class="col-lg-5 col-md-6 col-12 order-lg-1 min-vh-100 order-2 bg-white">
                <div class="p-5 m-4 login-block">
                    <div class="text-center mb-3">
                        <img src="@/assets/img/logo/logo.png" alt="logo" width="160" class="mt-2">
                    </div>
                    
                    <ValidationObserver ref="form">
                        <form>
                            <validation-provider rules="required|email" v-slot="{ errors }">
                                <div class="form-group">
                                    <label for="email">Email</label>
                                    <input id="email" v-model="email" type="email" class="form-control" name="email">
                                    <div class="invalid-input">{{ errors[0] }}</div>
                                </div>
                            </validation-provider>
                            
                            <validation-provider rules="required" v-slot="{ errors }">
                                <div class="form-group">
                                    <div class="d-block">
                                        <label for="password" class="control-label">Password</label>
                                    </div>
                                    <input id="password" type="password" v-model="password" class="form-control" name="password">
                                    <div class="invalid-input">{{ errors[0] }}</div>
                                </div>
                            </validation-provider>

                            <div class="form-group">
                                <button v-on:click="ManualLogin()" type="button" class="btn btn-new btn-lg btn-block">
                                    Login
                                </button>
                            </div>

                            
                            <div class="text-center mt-4 mb-3">
                                <div class="text-job text-muted">Need Help ?</div>
                            </div>
                            <div class="row sm-gutters">
                                <div class="col-12">
                                    <a href="https://wa.me/6283119354167?text=Halo, Saya Butuh Bantuan.." class="text-center bdr-100 btn btn-block btn-google-c">
                                        <span>
                                          <img src="@/assets/img/icon/wa.svg">
                                        </span> Whatsapp Now
                                    </a>
                                </div>
                            </div>
                        </form>
                    </ValidationObserver>

                </div>
            </div>
            <div class="col-lg-7 col-12 order-lg-2 order-1 min-vh-100 background-walk-y position-relative overlay-gradient-bottom" style="background-size: cover;" v-bind:style="{ backgroundImage: 'url(' + require(`@/assets/img/login3.jpg`) + ')' }">
                <div class="absolute-bottom-left index-2">
                    <div class="text-light p-5 pb-2">
                        <div class="mb-5 pb-3">
                            <h1 class="mb-2 display-4 font-weight-bold text-white">Uinvited !</h1>
                            <h5 class="font-weight-normal text-white">Digital invitation for your event</h5>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
    import {ValidationProvider, ValidationObserver } from "vee-validate";
    import { mapMutations, mapState } from 'vuex';
  
    export default {
        data(){
            return {
                email : "",
                password : "",
                loading_login:false,
            }
        },
        components: {
            ValidationProvider,
            ValidationObserver,
        },
        
        computed:{
            ...mapState('AuthControl', {
                errors_login: state => state.errors_login
            }),
        },
        watch:{
            errors_login:function(val){
                if(val.errors == 'l-failed'){
                    this.loading = false
                    this.loading_login = false
                    this.$toast.warning('Your user is not found, please complete the registration process')
                }else if(val.errors == 'l-unverified'){
                    this.loading = false
                    this.loading_login = false
                    this.alertLoginManual('Sorry you cant log in, please contact our support for this')
                }else if(val.errors == 'l-wrong'){
                    this.$toast.warning('Your email or password is wrong')
                }
            }
        },
        methods: {
            ...mapMutations('SignupControl', ['ASSIGN_DATA_SIGNUP_SOCIAL']),

            ManualLogin: function() {
                this.$refs.form.validate().then(success => {
                    if (!success) {
                        setTimeout(() => {
                            const errors = Object.entries(this.$refs.form.errors)
                                .map(([key, value]) => ({ key, value }))
                                .filter(error => error["value"].length);
                            this.$refs.form.refs[errors[0]["key"]].$el.scrollIntoView({
                                behavior: "smooth",
                                block: "center"
                            });
                        }, 100);
                    }else{
                        this.loading_login = true

                        let email = this.email 
                        let password = this.password
                        this.$store.dispatch('AuthControl/login', { email, password })
                        .then((response) => {
                            console.log(response)
                            this.loading_login = false
                            if(response.data.user.level == 1){
                                this.$router.push({name : 'dashboard'})
                            }else if(response.data.user.level == 2){
                                this.$router.push({name : 'distributor-dashboard'})
                            }else if(response.data.user.level == 3){
                                this.$router.push({name : 'agent-leaderboard'})
                            }
                        })
                        .catch((e) => {
                            console.error(e)
                            this.loading_login = false
                        })
                    }
                });
            },
            alertLoginManual: function(error){
                this.$swal({
                    title: 'Konfirmasi',
                    icon: 'warning',
                    text: error,
                    type: 'warning',
                    showCancelButton: false,
                    confirmButtonText: 'Keluar',
                })
            }
        }
    }
  </script>